//user
export const SET_USER="SET_USER";
export const SET_MESS="SET_MESS";

//recipe
export const SET_ALL_RECIPE="SET_ALL_RECIPE"
export const ADD_RECIPE="ADD_RECIPE"
export const DELETE_RECIPE="DELETE_RECIPE"

//bay

export const SET_BAY_BY_USER="SET_BAY_BY_USER"
export const DELETE_BAY_BY_USER="DELETE_BAY_BY_USER"
export const EDIT_BAY="EDIT_BAY"

//category

export const SET_ALL_CATEGORIES="SET_ALL_CATEGORIES"